import React, { ReactNode } from 'react';

import ConfirmModal from './ConfirmModal';

interface Props {
  open: boolean;
  subtitle?: string | ReactNode | undefined;
  loading?: boolean;
  onConfirm: any;
  onCancel?: any;
}

const DataPropagationConfirmModal = ({ open, subtitle, loading, onConfirm, onCancel }: Props) => {
  return (
    <ConfirmModal
      open={open}
      subtitle={subtitle}
      title={'Data Propagation Notice'}
      description={
        'You are about to save system-level changes that will affect displayed data for multiple companies and communities. Are you sure you want to do this?'
      }
      loading={loading}
      disabled={loading}
      checkboxConfirmLabel={'I understand that this will affect other companies and communities'}
      confirmLabel="Confirm & Save"
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};

export default DataPropagationConfirmModal;
